import React from "react";
import {
    Typography,
    Button,
    TextField,
    Select,
    MenuItem,
    Box,
    Card,
    CardContent,
    FormControl,
    InputLabel,
    useTheme,
    useMediaQuery
} from "@mui/material"
import {
    Loader
} from "../components/index"
import {
    useLazyUseGetAllPlatformsListQuery
} from "../Redux/actions/setting.action"
import {
    useLazyGetInstitutionClassesQuery
} from "../Redux/actions/classSetup.action"
import {
    updateFields,
    resetForm
} from "../Redux/actions/formValue.action"
import {
    useLazyGetAllExamsQuery,
    useSeeStudentResultMutation,
    useLazyGetStudentAdmitDetailsQuery
} from "../Redux/actions/examAction"
import {
    useDownloadMarksheetMutation
} from "../Redux/actions/certificate.action"
import { useSelector, useDispatch } from "react-redux"
import _ from "lodash"
import { useParams } from "react-router-dom"
import { useSnackbar } from "../components/Snakebar"

export default function PublicResults() {
    const { showSnackbar } = useSnackbar()
    const params = useParams()
    const dispatch = useDispatch()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const [platforms, setPlatforms] = React.useState([])
    const [classesList, setClassesList] = React.useState([])
    const [examListData, setExamList] = React.useState([])
    const [isInitialData, setIsInitialData] = React.useState(false)


    const { state } = useSelector((state) => state.form)


    const [getPlatformListAction, getPlatformListState] = useLazyUseGetAllPlatformsListQuery()
    const [getClassesAction, getClassesState] = useLazyGetInstitutionClassesQuery()
    const [getAllExams, getAllExamsState] = useLazyGetAllExamsQuery()
    const [downloadResult, downloadResultState] = useSeeStudentResultMutation()
    const [getStudentAdmitApi, getStudentAdmitStatus] = useLazyGetStudentAdmitDetailsQuery()
    const [downloadMarksheetApi, downloadMarksheetStatus] = useDownloadMarksheetMutation()


    function fetchInitialData() {
        if (Object.entries(params).length > 0) {
            const {
                school_id,
                class_id,
                exam_id,
                student_id
            } = params
            getStudentAdmitApi({
                school_id,
                class_id,
                exam_id,
                student_id
            })
        } else {
            getPlatformListAction()
        }
    }

    React.useEffect(() => {
        fetchInitialData()
        return () => {
            dispatch(resetForm())
        }
    }, [])

    React.useEffect(() => {
        if (downloadMarksheetStatus.isSuccess && downloadMarksheetStatus.data) {
            const blob = downloadMarksheetStatus.data
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement("a")
            a.href = url
            a.download = "exam_result.png"
            document.body.appendChild(a)
            a.click()
            a.remove()
            window.URL.revokeObjectURL(url)
            downloadMarksheetStatus.reset()
        }
        if (downloadMarksheetStatus.isError) {
            const errorMessage = _.get(downloadMarksheetStatus, "error.data.detail", "")
            showSnackbar({
                message: errorMessage,
                severity: "error"
            })
            downloadMarksheetStatus.reset()
            dispatch(resetForm())
        }
    }, [downloadMarksheetStatus.status])

    React.useEffect(() => {
        if (downloadResultState.isSuccess && downloadResultState.data) {
            const type = _.get(downloadResultState, "data.type", null)
            if (type && type === "pdf") {
                const blob = downloadResultState.data.data
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = url
                a.download = "exam_result.pdf"
                document.body.appendChild(a)
                a.click()
                a.remove()
                window.URL.revokeObjectURL(url)
                downloadResultState.reset()
                dispatch(resetForm())
            } else if (type && type === "json") {
                const data = _.get(downloadResultState, "data.data")
                downloadMarksheetApi(data)
                downloadResultState.reset()
            }
        }
        if (downloadResultState.isError) {
            const errorMessage = _.get(downloadResultState, "error.data.detail", "")
            showSnackbar({
                message: errorMessage,
                severity: "error"
            })
            downloadResultState.reset()
            dispatch(resetForm())
        }
    }, [downloadResultState.status])
    React.useEffect(() => {
        if (getStudentAdmitStatus.isSuccess) {
            const school = _.get(getStudentAdmitStatus, "currentData.school", [])
            const student = _.get(getStudentAdmitStatus, "currentData.student", [])
            const classdata = _.get(getStudentAdmitStatus, "currentData.class", [])
            const exam = _.get(getStudentAdmitStatus, "currentData.exam", [])
            setPlatforms(school)
            setClassesList(classdata)
            setExamList(exam)
            if (school.length && student.length && classdata.length && exam.length) {
                setIsInitialData(true)
                dispatch(updateFields({
                    institution_ref: school[0].id,
                    class_id: classdata[0].id,
                    rollNo: student[0]?.roll_no,
                    dob: student[0]?.dob,
                    exam: exam[0]?.id,
                    class_name: classdata[0]?.class_name
                }))
            }
        }
    }, [getStudentAdmitStatus.status])

    const platformList = React.useMemo(() => {
        if (getPlatformListState.isSuccess) {
            let list = _.get(getPlatformListState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getPlatformListState])
    const classes = React.useMemo(() => {
        if (getClassesState.isSuccess) {
            let list = _.get(getClassesState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getClassesState])
    const examList = React.useMemo(() => {
        if (getAllExamsState.isSuccess) {
            const list = _.get(getAllExamsState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getAllExamsState])


    React.useEffect(() => {
        if (platformList && platformList.length > 0) {
            setPlatforms(platformList)
        }
    }, [platformList])
    React.useEffect(() => {
        if (classes && classes.length > 0) {
            setClassesList(classes)
        }
    }, [classes])

    function fetchClassExams({
        school_id,
        class_id
    }) {
        if (!school_id || !class_id) return
        getAllExams({
            school_id,
            class_id
        })
    }

    function fetchStudentResult({
        school_id,
        class_id,
        roll_no,
        exam_id,
        dob = "NAN"
    }) {
        if (!school_id || !class_id || !roll_no || !exam_id) return
        const data = {
            school_id,
            class_id,
            roll_no: Number(roll_no),
            exam_id,
            dob: dob ? dob : "NAN"
        }
        downloadResult(data)
    }

    const schools = platformList && platformList.length > 0 ? platformList : platforms

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "calc(100vh - 64px)",
                background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 3,
                fontFamily: "var(--font-primary)"
            }}
        >
            <Card
                sx={{
                    width: isMobile ? "100%" : "550px",
                    borderRadius: "16px",
                    padding: isMobile ? 2 : 4,
                    boxShadow: "var(--shadow-premium)",
                    border: "1px solid var(--border-color)",
                    backgroundColor: "#ffffff",
                    overflow: "visible"
                }}
            >
                <CardContent>
                    {/* Header */}
                    <Typography
                        variant="h5"
                        sx={{
                            textAlign: "center",
                            fontWeight: 800,
                            marginBottom: 1,
                            fontFamily: "var(--font-heading)",
                            color: "var(--text-primary)",
                            fontSize: "26px"
                        }}
                    >
                        Check Your Examination Result
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: "center",
                            color: "var(--text-secondary)",
                            marginBottom: 4,
                            fontFamily: "var(--font-primary)",
                            fontSize: "14px"
                        }}
                    >
                        Select your institution, class, and enter academic details to fetch your digital result sheet.
                    </Typography>

                    {/* Form Fields */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                        {
                            schools && Array.isArray(schools) && schools.length > 0 && (
                                <FormControl fullWidth sx={{
                                    "& .MuiOutlinedInput-root": { borderRadius: "10px", fontFamily: "var(--font-primary)" },
                                    "& .MuiInputLabel-root": { fontFamily: "var(--font-primary)" }
                                }}>
                                    <InputLabel>Select School Or College</InputLabel>
                                    <Select
                                        label="Select School Or College"
                                        onChange={(e) => {
                                            let institution_ref = e.target.value
                                            if (institution_ref) {
                                                getClassesAction({
                                                    institution_ref: institution_ref
                                                })
                                            }
                                            dispatch(updateFields({ institution_ref: institution_ref }))
                                        }}
                                        value={_.get(state, "institution_ref", "")}
                                        disabled={isInitialData}
                                    >
                                        {
                                            schools.map((item, index) => {
                                                return (
                                                    <MenuItem value={item.id} key={index} sx={{ fontFamily: "var(--font-primary)" }}>{item.name.toUpperCase()}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }
                        {
                            classesList && Array.isArray(classesList) && classesList.length > 0 && (
                                <FormControl fullWidth sx={{
                                    "& .MuiOutlinedInput-root": { borderRadius: "10px", fontFamily: "var(--font-primary)" },
                                    "& .MuiInputLabel-root": { fontFamily: "var(--font-primary)" }
                                }}>
                                    <InputLabel>Select Class</InputLabel>
                                    <Select
                                        label="Select Class"
                                        disabled={isInitialData}
                                        onChange={(e) => {
                                            let class_id = e.target.value
                                            if (class_id) {
                                                dispatch(updateFields({ class_id: class_id }))
                                                let findClass = classesList.find((item) => item.id === class_id)
                                                if (findClass) {
                                                    fetchClassExams({
                                                        school_id: findClass.institution_ref,
                                                        class_id: findClass.id
                                                    })
                                                }
                                            }
                                        }}
                                        value={_.get(state, "class_id", "")}
                                    >
                                        {
                                            classesList.map((cl, index) => {
                                                return (
                                                    <MenuItem value={cl.id} key={`${index}+${cl.class_name}`} sx={{ fontFamily: "var(--font-primary)" }}>{cl.class_name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }

                        {
                            examList && Array.isArray(examList) && examList.length > 0 && (
                                <FormControl fullWidth sx={{
                                    "& .MuiOutlinedInput-root": { borderRadius: "10px", fontFamily: "var(--font-primary)" },
                                    "& .MuiInputLabel-root": { fontFamily: "var(--font-primary)" }
                                }}>
                                    <InputLabel>Select Exam</InputLabel>
                                    <Select
                                        label="Select Exam"
                                        disabled={isInitialData}
                                        onChange={(e) => {
                                            let exam = e.target.value
                                            if (exam) {
                                                dispatch(updateFields({ exam: exam }))
                                            }
                                        }}
                                        value={_.get(state, "exam", "")}
                                    >
                                        {
                                            examList.map((ex, index) => {
                                                return (
                                                    <MenuItem value={ex.id} key={`${ex.exam_name}+${index}`} sx={{ fontFamily: "var(--font-primary)" }}>{ex.exam_name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }

                        <TextField
                            fullWidth
                            label="Roll Number"
                            placeholder="Enter your roll number"
                            type="number"
                            sx={{
                                "& .MuiOutlinedInput-root": { borderRadius: "10px", fontFamily: "var(--font-primary)" },
                                "& .MuiInputLabel-root": { fontFamily: "var(--font-primary)" }
                            }}
                            onChange={(e) => {
                                let rollNo = e.target.value
                                dispatch(updateFields({ rollNo: rollNo }))
                            }}
                            value={_.get(state, "rollNo", "")}
                            disabled={isInitialData}
                        />

                        <TextField
                            fullWidth
                            label="Date of Birth"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                "& .MuiOutlinedInput-root": { borderRadius: "10px", fontFamily: "var(--font-primary)" },
                                "& .MuiInputLabel-root": { fontFamily: "var(--font-primary)" }
                            }}
                            onChange={(e) => {
                                let dob = e.target.value
                                dispatch(updateFields({ dob: dob }))
                            }}
                            value={_.get(state, "dob", "")}
                            disabled={isInitialData}
                        />

                        {/* Submit Button */}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                padding: "14px",
                                fontSize: "15px",
                                fontWeight: 750,
                                borderRadius: "10px",
                                marginTop: 2,
                                bgcolor: "var(--color-primary)",
                                textTransform: "none",
                                fontFamily: "var(--font-primary)",
                                boxShadow: "0 4px 6px -1px rgba(79, 70, 229, 0.2)",
                                "&:hover": {
                                    bgcolor: "var(--color-primary-hover)",
                                    boxShadow: "0 6px 12px -2px rgba(79, 70, 229, 0.3)"
                                },
                                transition: "all 0.2s ease-in-out"
                            }}
                            onClick={() => {
                                const school_id = _.get(state, "institution_ref", "")
                                const class_id = _.get(state, "class_id", "")
                                const exam_id = _.get(state, "exam", "")
                                const roll_no = _.get(state, "rollNo", "23-04-1996")
                                const dob = _.get(state, "dob", "")
                                fetchStudentResult({
                                    school_id,
                                    class_id,
                                    exam_id,
                                    roll_no: roll_no,
                                    dob
                                })
                            }}
                        >
                            View Result Sheet
                        </Button>
                    </Box>

                    {/* Footer */}
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            marginTop: 3,
                            textAlign: "center",
                            color: "var(--text-light)",
                            fontFamily: "var(--font-primary)"
                        }}
                    >
                        *Ensure entered academic credentials match official school records.
                    </Typography>
                </CardContent>
            </Card>
            {
                (
                    getPlatformListState.isLoading ||
                    getClassesState.isLoading ||
                    getAllExamsState.isLoading ||
                    downloadResultState.isLoading ||
                    downloadMarksheetStatus.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    )
}
